// react-bootstrap imports
import { Button, Form, Toast } from "react-bootstrap"
import { useLocation } from "react-router-dom"

// components imports
import { BotaoAutoPreenchimento } from "components/BotoesAuxiliaresDev"
import { BotaoVoltar, LoadingSpinner } from "components/Helpers"
import { AvisoGuiaExistente, BotaoLoading } from "components/FormGerarGuia"
import { AlertMessage, CustomToaster, SuccessDataLoaded, SuccessDataSaved, WarningNoData} from "components/AlertMessages"
// import { CheckboxInput, DateInput, DropdownInput, ListInput, NumberInput, TextAreaInput, TextInput, TextWithButtonInput } from "components/Inputs"

import { saveInputInCache } from "services/FormFunctions"

// service imports
import { DocForm } from "services/SectionsDocumentos"
import * as service from "services/TaxasCTM24/CalcularTaxaServico/GerarDocumento"

// custom hook
import { useGerarDocumento } from "hooks/useGerarDocumento"
 
// assets imports
import stdStyle from "json/StdStyles.json"
import { SERVICOSTAXAS } from "constants/servicosTaxasV2"
import { useAlert } from "hooks/useAlert"
import { MapboxMap } from "components/MapboxMap"

// const InputFieldFromObject = ({ field, amountGroupFields }) =>
// {
//     const {type, name, buttonText, buttonImg, itemsList, placeholder,
//             label, fields, value, numberLines, numberCols, req, info,
//             maxLength, min, mask, minWidth, onClick, onChange, onBlur} = field

//     let numberItems = 0
//     if (amountGroupFields[name])
//     {
//         numberItems = amountGroupFields[name]
//     }


//     switch (type)
//     {
//         case "textWithButton": return <TextWithButtonInput Name={name} Placeholder={placeholder} Label={label}
//                                                             ButtonText={buttonText} ButtonImg={buttonImg} Value={value} Req={req} Info={info} MaxLength={maxLength}
//                                                             Mask={mask} MinWidth={minWidth} OnBlur={onBlur} OnClick={onClick} />
//         case "checkbox": return <CheckboxInput Name={name} Label={label} Req={req} />
//         case "number": return <NumberInput Name={name} Placeholder={placeholder} Label={label} Value={value} Req={req} Info={info} Min={min}/>
//         case "text": return <TextInput Name={name} Placeholder={placeholder} Label={label} Value={value} Req={req}
//                                         Info={info} MaxLength={maxLength} Mask={mask} MinWidth={minWidth} OnBlur={onBlur} ValidationWarnings={warnValidate} ValidationErrors={errorValidate} />
//         case "textArea": return <TextAreaInput Name={name} Placeholder={placeholder} Label={label} Value={value}
//                                                 NumberLines={numberLines} NumberCols={numberCols} Req={req} Info={info} />
//         case "date" : return <DateInput Name={name} Label={label} Value={value} Req={req} Info={info} />
//         case "dropdown": return <DropdownInput Name={name} Value={value} Label={label} ItemsList={itemsList} MinWidth={minWidth} Req={req}
//                                                 OnChange={onChange} OnBlur={onBlur} />
//         case "listText": return <ListInput Type={type} name={name} placeholder={placeholder} label={label} value={value} req={req}
//                                             info={info} maxLength={maxLength} mask={mask} MinWidth={minWidth} InitNumberItems={numberItems} />
//         case "listTextArea": return <ListInput Type={type} name={name} placeholder={placeholder} value={value} label={label}
//                                                 numberLines={numberLines} numberCols={numberCols} req={req} info={info} InitNumberItems={numberItems} />
//         case "listDropdown": return <ListInput Type={type} name={name} itemsList={itemsList} value={value} InitNumberItems={numberItems} />
//         case "listGroupText": return <ListInput Type={type} name={name} fields={fields} MinWidth={minWidth} InitNumberItems={numberItems} />
//         default: return <div />
//     }
// }

// const FormFields = ({ Section, amountGroupFields }) =>
// {
//     const { inputs } = Section
//     const style = Section.sectionID === "observacoes" ? "" : "d-flex flex-wrap align-items-end"
    
//     return (
//         <div className = {style}>
//             {inputs.map((field, id) => <InputFieldFromObject field={field} amountGroupFields={amountGroupFields} key={field.name + id} />)}
//         </div>
//     )
// }

const FormSections = ({ tipoDoc, subTipoDoc, amountGroupFields }) =>
{
    return <DocForm tipoDoc={tipoDoc} subTipoDoc={subTipoDoc} amountGroupFields={amountGroupFields} />


    // let sections = documentSections(tipoDoc, subTipoDoc) ?? []
    // // const certificoSec = sections.filter(sec => sec.sectionName === "Certifico")[0]
    // const notasSec = sections.filter(sec => sec.sectionName === "Notas")[0]
    // const obsSec = sections.filter(sec => sec.sectionName === "Observações")[0]
    // if (obsSec)
    // {
    //     obsSec.inputs.filter(inp => inp.name === "obs")[0].value = obsDocumento(tipoDoc, subTipoDoc)
    // }
    // if (notasSec)
    // {
    //     notasSec.inputs.filter(inp => inp.name === "notas")[0].value = notasDocumento(tipoDoc)
    // }

    // for (let section of sections)
    // {
    //     if (Object.keys(section).length === 0)
    //     {
    //         return <ErrorSecaoVaziaMessage />
    //     }
    // }

    // return sections.map((section, id) =>
    //     <fieldset key={section.sectionName + id}>
    //         <LineWithText text={section.sectionName} align="Left" />
    //         <FormFields Section={section} amountGroupFields={amountGroupFields} />
    //     </fieldset>
    // )
}

const MapaDaCidade = ({ visible }) =>
{
    if (!visible) { return <></> }

    const style = visible ? "d-inline" : "d-none"
    
    return (     
        <Toast className={style + " bg-white position-absolute top-0 start-50 my-5 opacity-100"} style={{minWidth: "650px", minHeight:"650px"}} >
            <Toast.Header className="text-center" closeButton={false} >
                <strong className="me-auto text-dark">Mapa de Aracaju</strong>
            </Toast.Header>
            <Toast.Body className="opacity-100">            
                <MapboxMap />
            </Toast.Body>
        </Toast>   
    )
}

const BotaoGerarDocumento = ({ isLoading, textoSubmit }) =>
{
    if (isLoading) { return <BotaoLoading />}

    const botaoEnviarEstilo = "rounded-5 mx-2 my-auto"
    return <Button className={botaoEnviarEstilo} variant="success" type="submit" >{textoSubmit}</Button>
}

const BotaoSalvarDados = ({ tipoDoc, subTipoDoc, setShowAlertDataSaved }) =>
{
    function handleClick() {saveInputInCache(tipoDoc, subTipoDoc, setShowAlertDataSaved)}
    return <Button className="rounded-5 mx-2 my-2" variant="outline-primary" onClick={handleClick}>Salvar dados</Button>
}

const BotaoCarregarDados = ({ tipoDoc, subTipoDoc, setAmountGroupFields, setShowAlertNoData, setShowAlertDataLoaded }) =>
{
    function handleClick() {service.autoFillWithCache(tipoDoc, subTipoDoc, setAmountGroupFields, setShowAlertNoData, setShowAlertDataLoaded)}
    return <Button className="rounded-5 mx-2 my-2" variant="outline-primary" onClick={handleClick}>Carregar dados</Button>
}

const Botoes = ({ isLoading, tipoDoc, subTipoDoc, textoSubmit, setAmountGroupFields, setShowAlertDataSaved, setShowAlertDataLoaded, setShowAlertNoData, linkPrevPage, statePrevPage }) =>
{   
    return (
        <>
            <div className="d-flex justify-content-around my-3" >
                <BotaoVoltar linkPrevPage={linkPrevPage} statePrevPage={statePrevPage}/>
                <BotaoSalvarDados tipoDoc={tipoDoc} subTipoDoc={subTipoDoc} setShowAlertDataSaved={setShowAlertDataSaved} />
                <BotaoCarregarDados tipoDoc={tipoDoc} subTipoDoc={subTipoDoc} setAmountGroupFields={setAmountGroupFields}
                                    setShowAlertDataLoaded={setShowAlertDataLoaded} setShowAlertNoData={setShowAlertNoData} />
                <BotaoGerarDocumento textoSubmit={textoSubmit} isLoading={isLoading} />
            </div>
            <BotaoAutoPreenchimento />
        </>
    )
}

function mapServToDoc(guiaData)
{
    // const areaTerreno = guiaData?.detalhesGuia?.taxInputs?.areaTerreno
    // TODO checar
    // const servicosTaxas = []
    // for (let tipoServico of SERVICOSTAXAS)
    // {
    //     tipoServico.servicos.forEach(serv => servicosTaxas.push(serv))
    // }
    const tipoDoc = guiaData.detalhesGuia.tipoDocDestino
    const subTipoDoc = guiaData.detalhesGuia.subTipoDocDestino
    
    return {tipoDoc: tipoDoc, subTipoDoc: subTipoDoc}
}

export function dadosImovel(guiaData)
{
    return {
        logradouro: guiaData?.enderecoProprietario?.logradouroProprietario,
        numPorta: guiaData?.enderecoProprietario?.numPortaProprietario,
        bairro: guiaData?.enderecoProprietario?.bairroProprietario,
        cep: guiaData?.enderecoProprietario?.cepProprietario,
        complemento: guiaData?.enderecoProprietario?.complementoProprietario
    }
}

export const GerarDocumentoScreen = () =>
{
    // TODO Depois padronizar o retrieval de parametros, checar < CalcularTaxaCTM24Screen />, por exemplo.
    // Vamos pegar sempre o state ou vamos pegar o elemento do state?
    // guia data é recebido para gerar doc novo, dadosDoc é recebido para editar doc existente
    const {alert, showAlert, closeAlert} = useAlert()
    const location = useLocation()
    const { editar, procData, guiaData, guiaUsada, dadosDoc, linkPrevPage, statePrevPage } = location.state
    const { tipoDoc, subTipoDoc } = guiaData ? mapServToDoc(guiaData) : { tipoDoc: dadosDoc.tipoDoc, subTipoDoc: dadosDoc.subTipoDoc }
    const textoSubmit = editar? "Atualizar e Gerar PDF" : "Salvar e Gerar PDF"
    

    const 
    {
        isLoading,
        validated,
        showMap,
        showAlertNoData,
        setShowAlertNoData,
        showAlertDataSaved,
        setShowAlertDataSaved,
        showAlertDataLoaded,
        setShowAlertDataLoaded,
        toaster,
        amountGroupFields,
        setAmountGroupFields,
        onClickShowMap,
        handleSubmit
    } = useGerarDocumento(dadosDoc, guiaData, procData, tipoDoc, subTipoDoc, showAlert)
    
    return (
        <>
            <AlertMessage show={alert.show} variant={alert.variant} header={alert.header} message={alert.message} onClose={closeAlert} />
            <WarningNoData show={showAlertNoData} setShow={setShowAlertNoData} />
            <SuccessDataSaved show={showAlertDataSaved} setShow={setShowAlertDataSaved} />
            <SuccessDataLoaded show={showAlertDataLoaded} setShow={setShowAlertDataLoaded} />
            <CustomToaster toaster={toaster} />
            <Form className={stdStyle.taxForm} noValidate validated={validated} onSubmit={ async (event) => {handleSubmit(event, editar, tipoDoc, subTipoDoc, guiaData, dadosDoc)}} >                

                <p className="fw-bold text-center fs-6 pt-3">{service.idDocToNome(tipoDoc, subTipoDoc)}</p>
                <AvisoGuiaExistente procData={procData} showAvisoGuiaExistente={guiaUsada} />

                <Button onClick={onClickShowMap}>Ver mapa da cidade</Button>

                <FormSections tipoDoc={tipoDoc} subTipoDoc={subTipoDoc} amountGroupFields={amountGroupFields} />
                {/* TODO: refatorar essa questão dos "set" estarem aqui. Os set deveriam ser feitos nos hooks. */}
                <Botoes tipoDoc={tipoDoc}
                        subTipoDoc={subTipoDoc}
                        isLoading={isLoading} 
                        textoSubmit={textoSubmit}
                        setAmountGroupFields={setAmountGroupFields}
                        setShowAlertDataSaved={setShowAlertDataSaved}
                        setShowAlertDataLoaded={setShowAlertDataLoaded}
                        setShowAlertNoData={setShowAlertNoData}
                        linkPrevPage={linkPrevPage} 
                        statePrevPage={statePrevPage}  />
                <MapaDaCidade visible={showMap}/>

            </Form>
            <LoadingSpinner show={isLoading} />
        </>
    )

}